import { Fragment, useEffect, useState } from "react";
import PaginateMore from './pagination/PaginateMore.jsx'
import { PlainExplainPoints, colorizeBgPoints } from './ExplainPoints.jsx'
import { Tooltip } from 'react-tooltip'
import { LoadStandingsAuditUser } from "../repo/GroupsRepo.js";

export default function StandingsAuditUser({userId, userName, groupId, standingsAuditUserPage, totalPoints, includeLiveMatches, ...props}) {
  const [matches, setMatches] = useState([])
  const [pagination, setPagination] = useState(null)
  const [currentStandingsAuditUserPage, setCurrentStandingsAuditUserPage] = useState(1)
  const [loadedUserAudit, setLoadedUserAudit] = useState(false)

  let sumPoints = totalPoints

  function handlePaginationClick() {
    setCurrentStandingsAuditUserPage((previousPage) => previousPage + 1)
  }

  async function loadStandingsAuditUser(userId, groupId, standingsAuditUserPage) {
    const resData = await LoadStandingsAuditUser(userId, groupId, standingsAuditUserPage, includeLiveMatches)

    if (resData.pagination) {
      setMatches((currentMatches) => [...currentMatches, ...resData.data])
      setPagination(resData.pagination)
      setLoadedUserAudit(true)
    } else {
      setMatches([])
      setPagination({pagination: null})
    }
  }

  useEffect(() => {
    loadStandingsAuditUser(userId, groupId, currentStandingsAuditUserPage)
  }, [userId, groupId, currentStandingsAuditUserPage])

  return (
    <tr key={groupId + "s|s" + userId } id={groupId + "|" + userId} className="">
      <td colSpan="7" className="bg-slate-100">
          <div className="flex flex-row p-1 w-full text-xs justify-center align-middle" key={"header-" + userId}>
            <button id={`standings-audit-${userId}`} onClick={() => {props.OnAuditUserClick()}} className="text-sm text-green-500 hover:text-green-600">Fechar Auditoria</button>
            <Tooltip anchorSelect={`#standings-audit-${userId}`} place="top" type="dark" effect="float">
              Fechar
            </Tooltip>
          </div>
          <div className="gap-2 grid grid-cols-6 p-1 text-xs">
              <>
                <div className="col-span-4 font-semibold">
                  Placar/Palpite
                </div>
                <div className="col-span-1 text-right font-semibold">
                  Acumulou
                </div>
                <div className="col-span-1 text-right font-semibold">
                  Total
                </div>
              </>

          {matches && matches.length > 0 &&
          <>
            {matches.map((match, index) => {
              if (index > 0) {
                sumPoints -= matches[index - 1].bet_points
              }
              const bgColor = colorizeBgPoints(match.bet_points)
              return (
              <Fragment key={`${groupId}-${userId}-${match.match_id}-fragment|${Math.random()}`}>
                <div className="col-span-4 pl-1 hover:bg-slate-300" key={`${groupId}-${userId}-${match.match_id}col01`} id={`col01-${groupId}-${userId}-${match.match_id}`}>
                  {match.match_team_a_name} <b>{match.match_team_a_score}</b> x <b>{match.match_team_b_score}</b> {match.match_team_b_name} / <b>{match.bet_guess_score_team_a} x {match.bet_guess_score_team_b}</b>
                </div>
                <Tooltip anchorSelect={`#col01-${groupId}-${userId}-${match.match_id}`} place="top" type="dark" effect="float">
                  {<PlainExplainPoints points={match.bet_points} />}
                </Tooltip>
                <div className="col-span-1 text-right justify-items-end" key={`${groupId}-${userId}-${match.match_id}col02`}>
                  <span className={`text-white rounded-lg pr-2 w-14 block ${bgColor}`}>+{match.bet_points} pts</span>
                </div>
                <div className="col-span-1 text-right" key={`${groupId}-${userId}-${match.match_id}col03`}>
                  {sumPoints}
                </div>
              </Fragment>
            )})}
            <PaginateMore pagination={pagination} onPaginationClick={handlePaginationClick} />
          </>
          }
          </div>

          {matches && matches.length === 0 && loadedUserAudit && (
            <div className="px-4 py-1 w-full text-xs" key="no-bets">
              Nenhum palpite encontrado.
            </div>
          )}

          {matches && matches.length === 0 && !loadedUserAudit && (
            <div className="px-4 py-1 w-full text-xs" key="loading-bets">
              <svg className="mr-3 -ml-1 size-5 animate-spin text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
            </div>
          )}
      </td>
    </tr>
  )
}
